var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',_vm._g(_vm._b({staticClass:"fullscreen",attrs:{"visible":_vm.value,"header-bg-variant":"light","size":"xl","centered":"","hide-footer":"","title":_vm.title},on:{"change":function (e) { return _vm.$emit('input', e); }}},'b-modal',_vm.$attrs,false),_vm.$listeners),[_c('pdf-embed',{attrs:{"url":_vm.url,"alt-filename":_vm.altFilename}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1166c8e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalViewPdf.vue
// module id = null
// module chunks = 